import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import Icon from '../icon'
export default function CharityItem({ charity, onSelect, isSelected, disabled }) {
  const { t } = useTranslation()

  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (!disabled && onSelect) {
      onSelect(charity)
    }
  }

  const charityId = charity?.id || charity?.organization_id

  return (
    <Row 
      className="py-2 border-top align-items-center" 
      style={{ 
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer'
      }}
      onClick={!disabled ? handleClick : undefined}
    >
      <Col className="text-start">
        <div className="fw-bold text-capitalize">
          {charity.organization_name?.toLowerCase() || charity.name}
        </div>
        {charity.also_known_as && (
          <div className="text-muted small">
            {charity.also_known_as}
          </div>
        )}
        {charity.ein && (
          <div className="text-muted small">
            {charity.ein}
          </div>
        )}
        {(charity.city || charity.state) && (
          <div className="text-muted small">
            {[charity.city, charity.state].filter(Boolean).join(', ')}
          </div>
        )}
      </Col>
      <Col className="col-auto text-end" style={{ marginRight: '20px' }}>
        <button
          className="btn btn-link p-0 border-0"
          onClick={handleClick}
          disabled={disabled}
          type="button"
          aria-label={isSelected ? 'Remove default charity' : 'Set as default charity'}
          style={{ 
            pointerEvents: disabled ? 'none' : 'auto',
            fontSize: '24px',
            lineHeight: '1',
            minWidth: '30px'
          }}
        >
          <Icon
            name="circle-star"
            style={{
              fontSize: '24px',
              color: isSelected ? '#FFC107' : '#6c757d',
            }}
          />
        </button>
      </Col>
    </Row>
  )
}
